import { put, select } from "redux-saga/effects";

import actions from "@/actions";

/**
 * Persists light and marker changes from the current editing mode back to the global store.
 *
 * @yields Selects mode lights/markers and dispatches global store updates.
 */
function* persistModeLights() {
    try {
        const { lights, deletedLights, markers, shouldUpdate, mode } =
            yield select(({ map }) => ({
                ...map.values.mode.present,
                mode: map.general.mode.name,
                shouldUpdate: map.values.mode.past.length > 0,
            }));

        if (shouldUpdate) {
            if (mode === "select") {
                yield put(actions.map.values.global.setLights(lights));
            }
            yield put(actions.map.values.global.updateLights(lights));
            yield put(
                actions.map.values.global.updateDeleteLights(deletedLights),
            );
        }

        if (markers && Object.keys(markers).length > 0) {
            yield put(actions.map.values.global.updateMarkers(markers));
        }

        yield put(actions.map.general.changeMode("view"));
    } catch (err) {
        // eslint-disable-next-line no-console
        console.log("err on persisting the lights:", err);
    }
}

export default persistModeLights;
